import { Chain, ChainID } from '@ankr.com/chains-list';
import { createContext } from 'react';

import { ALL_CHAINS_VALUE } from './constants';

export interface ChainContextValue {
  chain: Chain | undefined;
  loading: boolean;
  partnerMainChainID: ChainID | undefined;
  selectedChainID: ChainID;
  setSelectedChainID: (chainID: ChainID) => void;
}

const defaultChainContextValue: ChainContextValue = {
  chain: undefined,
  loading: false,
  partnerMainChainID: undefined,
  selectedChainID: ALL_CHAINS_VALUE,
  setSelectedChainID: () => {},
};

export const ChainContext = createContext(defaultChainContextValue);
